export const countries = [
  {
    itemValue: 'United States of America',
    code: 'US',
    itemLabel: 'United States of America',
  },
  { itemValue: 'Mexico', code: 'MX', itemLabel: 'Mexico' },
  { itemValue: 'Canada', code: 'CA', itemLabel: 'Canada' },
  { itemValue: 'Argentina', code: 'AR', itemLabel: 'Argentina' },
  {
    itemValue: 'Antigua and Barbuda',
    code: 'AG',
    itemLabel: 'Antigua and Barbuda',
  },
  { itemValue: 'Aruba', code: 'AW', itemLabel: 'Aruba' },
  { itemValue: 'Barbados', code: 'BB', itemLabel: 'Barbados' },
  { itemValue: 'Belize', code: 'BZ', itemLabel: 'Belize' },
  { itemValue: 'Bermuda', code: 'BM', itemLabel: 'Bermuda' },
  { itemValue: 'Bolivia', code: 'BO', itemLabel: 'Bolivia' },
  { itemValue: 'Brazil', code: 'BR', itemLabel: 'Brazil' },
  { itemValue: 'Cayman Islands', code: 'KY', itemLabel: 'Cayman Islands' },
  { itemValue: 'Chile', code: 'CL', itemLabel: 'Chile' },
  { itemValue: 'Colombia', code: 'CO', itemLabel: 'Colombia' },
  { itemValue: 'Cook Islands', code: 'CK', itemLabel: 'Cook Islands' },
  { itemValue: 'Costa Rica', code: 'CR', itemLabel: 'Costa Rica' },
  { itemValue: 'Cuba', code: 'CU', itemLabel: 'Cuba' },
  { itemValue: 'Dominica', code: 'DM', itemLabel: 'Dominica' },
  {
    itemValue: 'Dominican Republic',
    code: 'DO',
    itemLabel: 'Dominican Republic',
  },
  { itemValue: 'Ecuador', code: 'EC', itemLabel: 'Ecuador' },
  { itemValue: 'El Salvador', code: 'SV', itemLabel: 'El Salvador' },
  {
    itemValue: 'Falkland Islands (Malvinas)',
    code: 'FK',
    itemLabel: 'Falkland Islands (Malvinas)',
  },
  { itemValue: 'Faroe Islands', code: 'FO', itemLabel: 'Faroe Islands' },
  { itemValue: 'French Guiana', code: 'GF', itemLabel: 'French Guiana' },
  { itemValue: 'Guadeloupe', code: 'GP', itemLabel: 'Guadeloupe' },
  { itemValue: 'Guatemala', code: 'GT', itemLabel: 'Guatemala' },
  { itemValue: 'Guyana', code: 'GY', itemLabel: 'Guyana' },
  { itemValue: 'Haiti', code: 'HT', itemLabel: 'Haiti' },
  { itemValue: 'Honduras', code: 'HN', itemLabel: 'Honduras' },
  { itemValue: 'Jamaica', code: 'JM', itemLabel: 'Jamaica' },
  { itemValue: 'Martinique', code: 'MQ', itemLabel: 'Martinique' },
  { itemValue: 'Nicaragua', code: 'NI', itemLabel: 'Nicaragua' },
  { itemValue: 'Panama', code: 'PA', itemLabel: 'Panama' },
  { itemValue: 'Paraguay', code: 'PY', itemLabel: 'Paraguay' },
  { itemValue: 'Peru', code: 'PE', itemLabel: 'Peru' },
  { itemValue: 'Puerto Rico', code: 'PR', itemLabel: 'Puerto Rico' },
  { itemValue: 'Saint Helena', code: 'SH', itemLabel: 'Saint Helena' },
  {
    itemValue: 'Saint Kitts and Nevis',
    code: 'KN',
    itemLabel: 'Saint Kitts and Nevis',
  },
  { itemValue: 'Saint Lucia', code: 'LC', itemLabel: 'Saint Lucia' },
  {
    itemValue: 'Saint Pierre and Miquelon',
    code: 'PM',
    itemLabel: 'Saint Pierre and Miquelon',
  },
  {
    itemValue: 'Saint Vincent and the Grenadines',
    code: 'VC',
    itemLabel: 'Saint Vincent and the Grenadines',
  },
  {
    itemValue: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    itemLabel: 'South Georgia and the South Sandwich Islands',
  },
  {
    itemValue: 'Trinidad and Tobago',
    code: 'TT',
    itemLabel: 'Trinidad and Tobago',
  },
  {
    itemValue: 'Turks and Caicos Islands',
    code: 'TC',
    itemLabel: 'Turks and Caicos Islands',
  },
  { itemValue: 'Uruguay', code: 'UY', itemLabel: 'Uruguay' },
  { itemValue: 'Venezuela', code: 'VE', itemLabel: 'Venezuela' },
  {
    itemValue: 'Virgin Islands, British',
    code: 'VG',
    itemLabel: 'Virgin Islands, British',
  },
  {
    itemValue: 'Virgin Islands, U.S.',
    code: 'VI',
    itemLabel: 'Virgin Islands, U.S.',
  },
  { itemValue: 'Bahamas', code: 'BS', itemLabel: 'Bahamas' },
  { itemValue: 'Afghanistan', code: 'AF', itemLabel: 'Afghanistan' },
  { itemValue: 'Åland Islands', code: 'AX', itemLabel: 'Åland Islands' },
  { itemValue: 'Albania', code: 'AL', itemLabel: 'Albania' },
  { itemValue: 'Algeria', code: 'DZ', itemLabel: 'Algeria' },
  { itemValue: 'American Samoa', code: 'AS', itemLabel: 'American Samoa' },
  { itemValue: 'AndorrA', code: 'AD', itemLabel: 'AndorrA' },
  { itemValue: 'Angola', code: 'AO', itemLabel: 'Angola' },
  { itemValue: 'Anguilla', code: 'AI', itemLabel: 'Anguilla' },
  { itemValue: 'Antarctica', code: 'AQ', itemLabel: 'Antarctica' },
  { itemValue: 'Armenia', code: 'AM', itemLabel: 'Armenia' },
  { itemValue: 'Australia', code: 'AU', itemLabel: 'Australia' },
  { itemValue: 'Austria', code: 'AT', itemLabel: 'Austria' },
  { itemValue: 'Azerbaijan', code: 'AZ', itemLabel: 'Azerbaijan' },
  { itemValue: 'Bahrain', code: 'BH', itemLabel: 'Bahrain' },
  { itemValue: 'Bangladesh', code: 'BD', itemLabel: 'Bangladesh' },
  { itemValue: 'Belarus', code: 'BY', itemLabel: 'Belarus' },
  { itemValue: 'Belgium', code: 'BE', itemLabel: 'Belgium' },
  { itemValue: 'Benin', code: 'BJ', itemLabel: 'Benin' },
  { itemValue: 'Bhutan', code: 'BT', itemLabel: 'Bhutan' },
  {
    itemValue: 'Bosnia and Herzegovina',
    code: 'BA',
    itemLabel: 'Bosnia and Herzegovina',
  },
  { itemValue: 'Botswana', code: 'BW', itemLabel: 'Botswana' },
  { itemValue: 'Bouvet Island', code: 'BV', itemLabel: 'Bouvet Island' },
  {
    itemValue: 'British Indian Ocean Territory',
    code: 'IO',
    itemLabel: 'British Indian Ocean Territory',
  },
  {
    itemValue: 'Brunei Darussalam',
    code: 'BN',
    itemLabel: 'Brunei Darussalam',
  },
  { itemValue: 'Bulgaria', code: 'BG', itemLabel: 'Bulgaria' },
  { itemValue: 'Burkina Faso', code: 'BF', itemLabel: 'Burkina Faso' },
  { itemValue: 'Burundi', code: 'BI', itemLabel: 'Burundi' },
  { itemValue: 'Cambodia', code: 'KH', itemLabel: 'Cambodia' },
  { itemValue: 'Cameroon', code: 'CM', itemLabel: 'Cameroon' },
  { itemValue: 'Cape Verde', code: 'CV', itemLabel: 'Cape Verde' },
  {
    itemValue: 'Central African Republic',
    code: 'CF',
    itemLabel: 'Central African Republic',
  },
  { itemValue: 'Chad', code: 'TD', itemLabel: 'Chad' },
  { itemValue: 'China', code: 'CN', itemLabel: 'China' },
  { itemValue: 'Christmas Island', code: 'CX', itemLabel: 'Christmas Island' },
  {
    itemValue: 'Cocos (Keeling) Islands',
    code: 'CC',
    itemLabel: 'Cocos (Keeling) Islands',
  },
  { itemValue: 'Comoros', code: 'KM', itemLabel: 'Comoros' },
  { itemValue: 'Congo', code: 'CG', itemLabel: 'Congo' },
  {
    itemValue: 'Congo, The Democratic Republic of the',
    code: 'CD',
    itemLabel: 'Congo, The Democratic Republic of the',
  },
  { itemValue: "Cote D'Ivoire", code: 'CI', itemLabel: "Cote D'Ivoire" },
  { itemValue: 'Croatia', code: 'HR', itemLabel: 'Croatia' },
  { itemValue: 'Cyprus', code: 'CY', itemLabel: 'Cyprus' },
  { itemValue: 'Czech Republic', code: 'CZ', itemLabel: 'Czech Republic' },
  { itemValue: 'Denmark', code: 'DK', itemLabel: 'Denmark' },
  { itemValue: 'Djibouti', code: 'DJ', itemLabel: 'Djibouti' },
  { itemValue: 'Egypt', code: 'EG', itemLabel: 'Egypt' },
  {
    itemValue: 'Equatorial Guinea',
    code: 'GQ',
    itemLabel: 'Equatorial Guinea',
  },
  { itemValue: 'Eritrea', code: 'ER', itemLabel: 'Eritrea' },
  { itemValue: 'Estonia', code: 'EE', itemLabel: 'Estonia' },
  { itemValue: 'Ethiopia', code: 'ET', itemLabel: 'Ethiopia' },
  { itemValue: 'Fiji', code: 'FJ', itemLabel: 'Fiji' },
  { itemValue: 'Finland', code: 'FI', itemLabel: 'Finland' },
  { itemValue: 'France', code: 'FR', itemLabel: 'France' },
  { itemValue: 'French Polynesia', code: 'PF', itemLabel: 'French Polynesia' },
  {
    itemValue: 'French Southern Territories',
    code: 'TF',
    itemLabel: 'French Southern Territories',
  },
  { itemValue: 'Gabon', code: 'GA', itemLabel: 'Gabon' },
  { itemValue: 'Gambia', code: 'GM', itemLabel: 'Gambia' },
  { itemValue: 'Georgia', code: 'GE', itemLabel: 'Georgia' },
  { itemValue: 'Germany', code: 'DE', itemLabel: 'Germany' },
  { itemValue: 'Ghana', code: 'GH', itemLabel: 'Ghana' },
  { itemValue: 'Gibraltar', code: 'GI', itemLabel: 'Gibraltar' },
  { itemValue: 'Greece', code: 'GR', itemLabel: 'Greece' },
  { itemValue: 'Greenland', code: 'GL', itemLabel: 'Greenland' },
  { itemValue: 'Grenada', code: 'GD', itemLabel: 'Grenada' },
  { itemValue: 'Guam', code: 'GU', itemLabel: 'Guam' },
  { itemValue: 'Guernsey', code: 'GG', itemLabel: 'Guernsey' },
  { itemValue: 'Guinea', code: 'GN', itemLabel: 'Guinea' },
  { itemValue: 'Guinea-Bissau', code: 'GW', itemLabel: 'Guinea-Bissau' },
  {
    itemValue: 'Heard Island and Mcdonald Islands',
    code: 'HM',
    itemLabel: 'Heard Island and Mcdonald Islands',
  },
  {
    itemValue: 'Holy See (Vatican City State)',
    code: 'VA',
    itemLabel: 'Holy See (Vatican City State)',
  },
  { itemValue: 'Hong Kong', code: 'HK', itemLabel: 'Hong Kong' },
  { itemValue: 'Hungary', code: 'HU', itemLabel: 'Hungary' },
  { itemValue: 'Iceland', code: 'IS', itemLabel: 'Iceland' },
  { itemValue: 'India', code: 'IN', itemLabel: 'India' },
  { itemValue: 'Indonesia', code: 'ID', itemLabel: 'Indonesia' },
  {
    itemValue: 'Iran, Islamic Republic Of',
    code: 'IR',
    itemLabel: 'Iran, Islamic Republic Of',
  },
  { itemValue: 'Iraq', code: 'IQ', itemLabel: 'Iraq' },
  { itemValue: 'Ireland', code: 'IE', itemLabel: 'Ireland' },
  { itemValue: 'Isle of Man', code: 'IM', itemLabel: 'Isle of Man' },
  { itemValue: 'Israel', code: 'IL', itemLabel: 'Israel' },
  { itemValue: 'Italy', code: 'IT', itemLabel: 'Italy' },
  { itemValue: 'Japan', code: 'JP', itemLabel: 'Japan' },
  { itemValue: 'Jersey', code: 'JE', itemLabel: 'Jersey' },
  { itemValue: 'Jordan', code: 'JO', itemLabel: 'Jordan' },
  { itemValue: 'Kazakhstan', code: 'KZ', itemLabel: 'Kazakhstan' },
  { itemValue: 'Kenya', code: 'KE', itemLabel: 'Kenya' },
  { itemValue: 'Kiribati', code: 'KI', itemLabel: 'Kiribati' },
  {
    itemValue: "Korea, Democratic People'S Republic of",
    code: 'KP',
    itemLabel: "Korea, Democratic People'S Republic of",
  },
  {
    itemValue: 'Korea, Republic of',
    code: 'KR',
    itemLabel: 'Korea, Republic of',
  },
  { itemValue: 'Kuwait', code: 'KW', itemLabel: 'Kuwait' },
  { itemValue: 'Kyrgyzstan', code: 'KG', itemLabel: 'Kyrgyzstan' },
  {
    itemValue: "Lao People'S Democratic Republic",
    code: 'LA',
    itemLabel: "Lao People'S Democratic Republic",
  },
  { itemValue: 'Latvia', code: 'LV', itemLabel: 'Latvia' },
  { itemValue: 'Lebanon', code: 'LB', itemLabel: 'Lebanon' },
  { itemValue: 'Lesotho', code: 'LS', itemLabel: 'Lesotho' },
  { itemValue: 'Liberia', code: 'LR', itemLabel: 'Liberia' },
  {
    itemValue: 'Libyan Arab Jamahiriya',
    code: 'LY',
    itemLabel: 'Libyan Arab Jamahiriya',
  },
  { itemValue: 'Liechtenstein', code: 'LI', itemLabel: 'Liechtenstein' },
  { itemValue: 'Lithuania', code: 'LT', itemLabel: 'Lithuania' },
  { itemValue: 'Luxembourg', code: 'LU', itemLabel: 'Luxembourg' },
  { itemValue: 'Macao', code: 'MO', itemLabel: 'Macao' },
  {
    itemValue: 'Macedonia, The Former Yugoslav Republic of',
    code: 'MK',
    itemLabel: 'Macedonia, The Former Yugoslav Republic of',
  },
  { itemValue: 'Madagascar', code: 'MG', itemLabel: 'Madagascar' },
  { itemValue: 'Malawi', code: 'MW', itemLabel: 'Malawi' },
  { itemValue: 'Malaysia', code: 'MY', itemLabel: 'Malaysia' },
  { itemValue: 'Maldives', code: 'MV', itemLabel: 'Maldives' },
  { itemValue: 'Mali', code: 'ML', itemLabel: 'Mali' },
  { itemValue: 'Malta', code: 'MT', itemLabel: 'Malta' },
  { itemValue: 'Marshall Islands', code: 'MH', itemLabel: 'Marshall Islands' },
  { itemValue: 'Mauritania', code: 'MR', itemLabel: 'Mauritania' },
  { itemValue: 'Mauritius', code: 'MU', itemLabel: 'Mauritius' },
  { itemValue: 'Mayotte', code: 'YT', itemLabel: 'Mayotte' },
  {
    itemValue: 'Micronesia, Federated States of',
    code: 'FM',
    itemLabel: 'Micronesia, Federated States of',
  },
  {
    itemValue: 'Moldova, Republic of',
    code: 'MD',
    itemLabel: 'Moldova, Republic of',
  },
  { itemValue: 'Monaco', code: 'MC', itemLabel: 'Monaco' },
  { itemValue: 'Mongolia', code: 'MN', itemLabel: 'Mongolia' },
  { itemValue: 'Montserrat', code: 'MS', itemLabel: 'Montserrat' },
  { itemValue: 'Morocco', code: 'MA', itemLabel: 'Morocco' },
  { itemValue: 'Mozambique', code: 'MZ', itemLabel: 'Mozambique' },
  { itemValue: 'Myanmar', code: 'MM', itemLabel: 'Myanmar' },
  { itemValue: 'Namibia', code: 'NA', itemLabel: 'Namibia' },
  { itemValue: 'Nauru', code: 'NR', itemLabel: 'Nauru' },
  { itemValue: 'Nepal', code: 'NP', itemLabel: 'Nepal' },
  { itemValue: 'Netherlands', code: 'NL', itemLabel: 'Netherlands' },
  {
    itemValue: 'Netherlands Antilles',
    code: 'AN',
    itemLabel: 'Netherlands Antilles',
  },
  { itemValue: 'New Caledonia', code: 'NC', itemLabel: 'New Caledonia' },
  { itemValue: 'New Zealand', code: 'NZ', itemLabel: 'New Zealand' },
  { itemValue: 'Niger', code: 'NE', itemLabel: 'Niger' },
  { itemValue: 'Nigeria', code: 'NG', itemLabel: 'Nigeria' },
  { itemValue: 'Niue', code: 'NU', itemLabel: 'Niue' },
  { itemValue: 'Norfolk Island', code: 'NF', itemLabel: 'Norfolk Island' },
  {
    itemValue: 'Northern Mariana Islands',
    code: 'MP',
    itemLabel: 'Northern Mariana Islands',
  },
  { itemValue: 'Norway', code: 'NO', itemLabel: 'Norway' },
  { itemValue: 'Oman', code: 'OM', itemLabel: 'Oman' },
  { itemValue: 'Pakistan', code: 'PK', itemLabel: 'Pakistan' },
  { itemValue: 'Palau', code: 'PW', itemLabel: 'Palau' },
  {
    itemValue: 'Palestinian Territory, Occupied',
    code: 'PS',
    itemLabel: 'Palestinian Territory, Occupied',
  },
  { itemValue: 'Papua New Guinea', code: 'PG', itemLabel: 'Papua New Guinea' },
  { itemValue: 'Philippines', code: 'PH', itemLabel: 'Philippines' },
  { itemValue: 'Pitcairn', code: 'PN', itemLabel: 'Pitcairn' },
  { itemValue: 'Poland', code: 'PL', itemLabel: 'Poland' },
  { itemValue: 'Portugal', code: 'PT', itemLabel: 'Portugal' },
  { itemValue: 'Qatar', code: 'QA', itemLabel: 'Qatar' },
  { itemValue: 'Reunion', code: 'RE', itemLabel: 'Reunion' },
  { itemValue: 'Romania', code: 'RO', itemLabel: 'Romania' },
  {
    itemValue: 'Russian Federation',
    code: 'RU',
    itemLabel: 'Russian Federation',
  },
  { itemValue: 'RWANDA', code: 'RW', itemLabel: 'RWANDA' },
  { itemValue: 'Samoa', code: 'WS', itemLabel: 'Samoa' },
  { itemValue: 'San Marino', code: 'SM', itemLabel: 'San Marino' },
  {
    itemValue: 'Sao Tome and Principe',
    code: 'ST',
    itemLabel: 'Sao Tome and Principe',
  },
  { itemValue: 'Saudi Arabia', code: 'SA', itemLabel: 'Saudi Arabia' },
  { itemValue: 'Senegal', code: 'SN', itemLabel: 'Senegal' },
  {
    itemValue: 'Serbia and Montenegro',
    code: 'CS',
    itemLabel: 'Serbia and Montenegro',
  },
  { itemValue: 'Seychelles', code: 'SC', itemLabel: 'Seychelles' },
  { itemValue: 'Sierra Leone', code: 'SL', itemLabel: 'Sierra Leone' },
  { itemValue: 'Singapore', code: 'SG', itemLabel: 'Singapore' },
  { itemValue: 'Slovakia', code: 'SK', itemLabel: 'Slovakia' },
  { itemValue: 'Slovenia', code: 'SI', itemLabel: 'Slovenia' },
  { itemValue: 'Solomon Islands', code: 'SB', itemLabel: 'Solomon Islands' },
  { itemValue: 'Somalia', code: 'SO', itemLabel: 'Somalia' },
  { itemValue: 'South Africa', code: 'ZA', itemLabel: 'South Africa' },
  { itemValue: 'Spain', code: 'ES', itemLabel: 'Spain' },
  { itemValue: 'Sri Lanka', code: 'LK', itemLabel: 'Sri Lanka' },
  { itemValue: 'Sudan', code: 'SD', itemLabel: 'Sudan' },
  { itemValue: 'SuriitemValue', code: 'SR', itemLabel: 'SuriitemValue' },
  {
    itemValue: 'Svalbard and Jan Mayen',
    code: 'SJ',
    itemLabel: 'Svalbard and Jan Mayen',
  },
  { itemValue: 'Swaziland', code: 'SZ', itemLabel: 'Swaziland' },
  { itemValue: 'Sweden', code: 'SE', itemLabel: 'Sweden' },
  { itemValue: 'Switzerland', code: 'CH', itemLabel: 'Switzerland' },
  {
    itemValue: 'Syrian Arab Republic',
    code: 'SY',
    itemLabel: 'Syrian Arab Republic',
  },
  {
    itemValue: 'Taiwan, Province of China',
    code: 'TW',
    itemLabel: 'Taiwan, Province of China',
  },
  { itemValue: 'Tajikistan', code: 'TJ', itemLabel: 'Tajikistan' },
  {
    itemValue: 'Tanzania, United Republic of',
    code: 'TZ',
    itemLabel: 'Tanzania, United Republic of',
  },
  { itemValue: 'Thailand', code: 'TH', itemLabel: 'Thailand' },
  { itemValue: 'Timor-Leste', code: 'TL', itemLabel: 'Timor-Leste' },
  { itemValue: 'Togo', code: 'TG', itemLabel: 'Togo' },
  { itemValue: 'Tokelau', code: 'TK', itemLabel: 'Tokelau' },
  { itemValue: 'Tonga', code: 'TO', itemLabel: 'Tonga' },
  { itemValue: 'Tunisia', code: 'TN', itemLabel: 'Tunisia' },
  { itemValue: 'Turkey', code: 'TR', itemLabel: 'Turkey' },
  { itemValue: 'Turkmenistan', code: 'TM', itemLabel: 'Turkmenistan' },
  { itemValue: 'Tuvalu', code: 'TV', itemLabel: 'Tuvalu' },
  { itemValue: 'Uganda', code: 'UG', itemLabel: 'Uganda' },
  { itemValue: 'Ukraine', code: 'UA', itemLabel: 'Ukraine' },
  {
    itemValue: 'United Arab Emirates',
    code: 'AE',
    itemLabel: 'United Arab Emirates',
  },
  { itemValue: 'United Kingdom', code: 'GB', itemLabel: 'United Kingdom' },
  {
    itemValue: 'United States Minor Outlying Islands',
    code: 'UM',
    itemLabel: 'United States Minor Outlying Islands',
  },
  { itemValue: 'Uzbekistan', code: 'UZ', itemLabel: 'Uzbekistan' },
  { itemValue: 'Vanuatu', code: 'VU', itemLabel: 'Vanuatu' },
  { itemValue: 'Viet Nam', code: 'VN', itemLabel: 'Viet Nam' },
  {
    itemValue: 'Wallis and Futuna',
    code: 'WF',
    itemLabel: 'Wallis and Futuna',
  },
  { itemValue: 'Western Sahara', code: 'EH', itemLabel: 'Western Sahara' },
  { itemValue: 'Yemen', code: 'YE', itemLabel: 'Yemen' },
  { itemValue: 'Zambia', code: 'ZM', itemLabel: 'Zambia' },
  { itemValue: 'Zimbabwe', code: 'ZW', itemLabel: 'Zimbabwe' },
]
